var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "api-doc-page" },
    [
      _c("a-card", { staticClass: "base-info-card" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("商户接口信息")]),
        _c("div", { staticClass: "base-info-row" }, [
          _c("div", { staticClass: "base-info-left" }, [
            _c("div", [
              _c("span", { staticClass: "label" }, [_vm._v("商户ID：")]),
              _c("span", [_vm._v(_vm._s(_vm.merchantId))]),
            ]),
            _c(
              "div",
              { staticStyle: { "margin-top": "16px" } },
              [
                _c("span", { staticClass: "label" }, [_vm._v("选择应用：")]),
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "360px" },
                    attrs: { placeholder: "请选择应用" },
                    model: {
                      value: _vm.appId,
                      callback: function ($$v) {
                        _vm.appId = $$v
                      },
                      expression: "appId",
                    },
                  },
                  _vm._l(_vm.apps, function (app) {
                    return _c(
                      "a-select-option",
                      { key: app.appId, attrs: { value: app.appId } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(app.appName) +
                            " [" +
                            _vm._s(app.appId) +
                            "] "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "16px" } },
              [
                _c("span", { staticClass: "label" }, [_vm._v("密钥：")]),
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      loading: _vm.secretLoading,
                    },
                    on: { click: _vm.getSecret },
                  },
                  [_vm._v(" 点击查看密钥 ")]
                ),
                _c(
                  "a-modal",
                  {
                    attrs: { title: "查看密钥", footer: null },
                    on: {
                      cancel: function ($event) {
                        _vm.showSecret = false
                      },
                    },
                    model: {
                      value: _vm.showSecret,
                      callback: function ($$v) {
                        _vm.showSecret = $$v
                      },
                      expression: "showSecret",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "16px" } },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("商户ID："),
                        ]),
                        _c("span", [_vm._v(_vm._s(_vm.merchantId))]),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.copyText(_vm.merchantId)
                              },
                            },
                          },
                          [_vm._v("复制商户ID")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "16px" } },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("应用ID："),
                        ]),
                        _c("span", [_vm._v(_vm._s(_vm.appId) + " ")]),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.copyText(_vm.appId)
                              },
                            },
                          },
                          [_vm._v("复制应用ID")]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { "margin-bottom": "16px" } }, [
                      _vm.secret !== null
                        ? _c(
                            "div",
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("密钥："),
                              ]),
                              _c("a-textarea", {
                                attrs: {
                                  rows: 3,
                                  value: _vm.secret,
                                  readonly: "",
                                },
                              }),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-top": "8px" },
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyText(_vm.secret)
                                    },
                                  },
                                },
                                [_vm._v("复制密钥")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.secret !== null
                        ? _c(
                            "div",
                            { staticStyle: { "margin-top": "16px" } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.copyAllInfo },
                                },
                                [_vm._v("复制全部信息")]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [_c("a-spin"), _vm._v(" 正在获取密钥... ")],
                            1
                          ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "base-info-right" }, [
            _c(
              "div",
              [
                _c("span", { staticClass: "label" }, [_vm._v("在线文档：")]),
                _c(
                  "a-button",
                  {
                    staticStyle: { "margin-right": "8px" },
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.openDoc("pay")
                      },
                    },
                  },
                  [_vm._v("☑ 对接文档")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "16px" } },
              [
                _c("span", { staticClass: "label" }, [_vm._v("demo下载：")]),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", size: "small", ghost: "" },
                    on: { click: _vm.downloadDemo },
                  },
                  [_vm._v("☉ java")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "16px" } },
              [
                _c("span", { staticClass: "label" }, [_vm._v("sdk下载：")]),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", size: "small", ghost: "" },
                    on: { click: _vm.downloadSdk },
                  },
                  [_vm._v("下载")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "a-card",
        { staticClass: "base-info-card" },
        [
          _c("div", { staticClass: "section-title" }, [_vm._v("通道列表")]),
          _c("jeepay-table", {
            ref: "channelTable",
            attrs: {
              initData: true,
              reqTableDataFunc: _vm.reqTableDataFunc,
              tableColumns: _vm.tableColumns,
              rowKey: "id",
              tableRowCrossColor: true,
            },
            scopedSlots: _vm._u([
              {
                key: "rateSlot",
                fn: function ({ record }) {
                  return [
                    _c("a-tag", { attrs: { color: "blue" } }, [
                      _vm._v(_vm._s(record.rate) + "%"),
                    ]),
                  ]
                },
              },
              {
                key: "minOrderAmountSlot",
                fn: function ({ record }) {
                  return [
                    _c("span", { staticClass: "amount-text" }, [
                      _vm._v(_vm._s(_vm.formatAmount(record.minOrderAmount))),
                    ]),
                  ]
                },
              },
              {
                key: "maxOrderAmountSlot",
                fn: function ({ record }) {
                  return [
                    _c("span", { staticClass: "amount-text" }, [
                      _vm._v(_vm._s(_vm.formatAmount(record.maxOrderAmount))),
                    ]),
                  ]
                },
              },
              {
                key: "fixedFeeAmountSlot",
                fn: function ({ record }) {
                  return [
                    _c("span", { staticClass: "fee-text" }, [
                      _vm._v(_vm._s(_vm.formatFeeDisplay(record))),
                    ]),
                  ]
                },
              },
              {
                key: "singleAccountPayLimitSlot",
                fn: function ({ record }) {
                  return [
                    _c("span", { staticClass: "amount-text" }, [
                      _vm._v(
                        _vm._s(_vm.formatAmount(record.singleAccountPayLimit))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "stateSlot",
                fn: function ({ record }) {
                  return [
                    _c("a-badge", {
                      attrs: {
                        status: record.state === 1 ? "processing" : "error",
                        text: record.state === 1 ? "启用" : "停用",
                      },
                    }),
                  ]
                },
              },
              {
                key: "payTypeSlot",
                fn: function ({ record }) {
                  return [
                    _c(
                      "a-tag",
                      { attrs: { color: _vm.getPayTypeColor(record.payType) } },
                      [_vm._v(_vm._s(_vm.getPayTypeText(record.payType)))]
                    ),
                  ]
                },
              },
              {
                key: "channelNameSlot",
                fn: function ({ record }) {
                  return [
                    _c("div", { staticClass: "channel-name-text" }, [
                      _vm._v(_vm._s(record.wayName || "--")),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }